import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=f7956356&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7956356')) {
      api.createRecord('f7956356', component.options)
    } else {
      api.reload('f7956356', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=f7956356&", function () {
      api.rerender('f7956356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24UlAZUunV0KD/JS/comp/ErrorMessage.vue"
export default component.exports